module.exports = __webpack_public_path__ + "img/loader.56fd6e53.gif";